export const SPREADSHEET_ID = "1NgRmsAkdekwA6DEvKJCKq5fmlnh-cJcBxskg22AunM4";

// data keys for pools A & B
export const POOL_A = {
    dataKey: "POOL_A",
    range: "Pool Playes Overview!A1:J6",
};
export const POOL_B = {
    dataKey: "POOL_B",
    range: "Pool Playes Overview!A7:J12",
};

// data keys for agenda (pool rounds 1 - 5 + bracket)
export const AGENDA_HEADER = {
    dataKey: "AGENDA_HEADER",
    range: "10 teams format!A1:L1",
};
export const AGENDA_ROUND_1 = {
    dataKey: "AGENDA_ROUND_1",
    range: "10 teams format!A3:L4",
};
export const AGENDA_ROUND_2 = {
    dataKey: "AGENDA_ROUND_2",
    range: "10 teams format!A6:L7",
};
export const AGENDA_ROUND_3 = {
    dataKey: "AGENDA_ROUND_3",
    range: "10 teams format!A9:L10",
};
export const AGENDA_ROUND_4 = {
    dataKey: "AGENDA_ROUND_4",
    range: "10 teams format!A12:L13",
};
export const AGENDA_ROUND_5 = {
    dataKey: "AGENDA_ROUND_5",
    range: "10 teams format!A15:L16",
};
// agenda -> braket
export const AGENDA_ROUND_6 = {
    dataKey: "AGENDA_ROUND_6",
    range: "10 Teams bracket!AG3:AN3",
};
export const AGENDA_ROUND_7 = {
    dataKey: "AGENDA_ROUND_7",
    range: "10 Teams bracket!AG4:AN4",
};
export const AGENDA_ROUND_8 = {
    dataKey: "AGENDA_ROUND_8",
    range: "10 Teams bracket!AG5:AN5",
};
export const AGENDA_ROUND_9 = {
    dataKey: "AGENDA_ROUND_9",
    range: "10 Teams bracket!AG6:AN6",
};
export const AGENDA_AWARDS = {
    dataKey: "AGENDA_AWARDS",
    range: "10 Teams bracket!AG7:AN7",
};

// data keys for bracket
export const BRACKET_HEADER = {
    dataKey: "BRACKET_HEADER",
    range: "10 Teams bracket!Y1:AA1",
};
export const BRACKET_ROUND_G1 = {
    dataKey: "BRACKET_ROUND_G1",
    range: "10 Teams bracket!Y2:AA3",
};
export const BRACKET_ROUND_G2 = {
    dataKey: "BRACKET_ROUND_G2",
    range: "10 Teams bracket!Y4:AA5",
};
export const BRACKET_ROUND_G3 = {
    dataKey: "BRACKET_ROUND_G3",
    range: "10 Teams bracket!Y6:AA7",
};
export const BRACKET_ROUND_G4 = {
    dataKey: "BRACKET_ROUND_G4",
    range: "10 Teams bracket!Y8:AA9",
};
export const BRACKET_ROUND_G5 = {
    dataKey: "BRACKET_ROUND_G5",
    range: "10 Teams bracket!Y10:AA11",
};
export const BRACKET_ROUND_G6 = {
    dataKey: "BRACKET_ROUND_G6",
    range: "10 Teams bracket!Y12:AA13",
};
export const BRACKET_ROUND_G7 = {
    dataKey: "BRACKET_ROUND_G7",
    range: "10 Teams bracket!Y14:AA15",
};
export const BRACKET_ROUND_G8 = {
    dataKey: "BRACKET_ROUND_G8",
    range: "10 Teams bracket!Y16:AA17",
};
export const BRACKET_ROUND_G9 = {
    dataKey: "BRACKET_ROUND_G9",
    range: "10 Teams bracket!Y18:AA19",
};
export const BRACKET_ROUND_G10 = {
    dataKey: "BRACKET_ROUND_G10",
    range: "10 Teams bracket!Y20:AA21",
};
// brackets - placements
export const BRACKET_9TH_PLACE = {
    dataKey: "BRACKET_9TH_PLACE",
    range: "10 Teams bracket!Y23:AA24",
};
export const BRACKET_3RD_PLACE = {
    dataKey: "BRACKET_3RD_PLACE",
    range: "10 Teams bracket!Y25:AA26",
};
export const BRACKET_1ST_PLACE = {
    dataKey: "BRACKET_1ST_PLACE",
    range: "10 Teams bracket!Y27:AA28",
};
// brackets - overall ranking
export const BRACKET_RANKINGS = {
    dataKey: "BRACKET_RANKINGS",
    range: "Pool Playes Overview!A15:D25",
};
